import { DashboardResponse } from '@com-delta-idp/mnx-oauth';
import { USERNAME } from '../../constants/analytics.constants';
import {
  DATA_ANALYTICS,
  USER_LOGGED_IN_STATUS
} from '../../enum/analytics.enum';
import { User } from '../../interface/analytics.interface';

export const getUserData = (response: DashboardResponse): User => {
  return {
    attributes: {
      is_logged_in: USER_LOGGED_IN_STATUS.AUTHENTICATED,
      login_method: USERNAME,
      login_state: USER_LOGGED_IN_STATUS.HOT
    },
    profile: getUserProfile(response)
  };
};

export const getUserProfile = (response: DashboardResponse) => {
  return {
    email: addNullCheck(response?.primaryEmailAddress),
    encrypted_email: '',
    email_domain: getEmailDomain(response?.primaryEmailAddress),
    skymiles_number: addNullCheck(response?.smNumber),
    skymiles_tier: addNullCheck(response?.membershipLevel),
    company_name: addNullCheck(response.smeCompanyName),
    ...getAccountData(response)
  };
};

export const getAccountData = (response: DashboardResponse) => {
  return {
    available_miles: addNullCheck(response.smBalance),
    amex_card_type: addNullCheck(response.medallionMemberDesc?.split(' ')[0])
  };
};

export const getEmailDomain = (email: string | undefined): string => {
  return email?.split(DATA_ANALYTICS.EMAIL_SPLIT_SYMBOL)?.[1] || '';
};

export const getLinkType = (href: string): string => {
  const isExternal =
    href.startsWith(DATA_ANALYTICS.HTTP) &&
    !href.includes(window.location.hostname);
  return isExternal
    ? DATA_ANALYTICS.EXTERNAL_LINK
    : DATA_ANALYTICS.INTERNAL_LINK;
};

export const addNullCheck = (data: string): string => data || '';

export const getClickEvent = (type: string): string => type; //TODO: replace type with logic
